import { AlertCircle, Inbox, LoaderCircle } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "./Button";
import { isReplacementReason } from '../lib/auth';
import { aiDisplayText } from "../lib/ai-display";

export function LoadingState({ label = "正在加载" }: { label?: string }) {
  return (
    <div className="feedback" role="status" aria-live="polite">
      <LoaderCircle className="feedback__spin" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry?: () => void;
}) {
  const message = error instanceof Error ? error.message : "请稍后重试";
  const replaced = isReplacementReason(error && typeof error === 'object' && 'code' in error ? error.code : undefined);
  const permissionDenied = /403|权限|无权|forbidden/i.test(message);
  return (
    <div className="feedback feedback--error" role="alert">
      <AlertCircle />
      <div>
        <strong>{replaced ? "账号已在另一台电脑登录" : permissionDenied ? "权限不足" : "加载失败"}</strong>
        <p>{aiDisplayText(message)}</p>
      </div>
      {onRetry ? (
        <Button size="small" onClick={onRetry}>
          重试
        </Button>
      ) : null}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="empty-state">
      {icon ?? <Inbox />}
      <strong>{title}</strong>
      <p>{description}</p>
      {action}
    </div>
  );
}
